<template>
  <layout-general v-if="modalVisible === 'cant-export'" @close="modalClose()">
    <h4 class="modal-title" slot="header">{{ $t('modal.cant_export_table.title') }}</h4>
    <div slot="body">
      <div>
        <h4 class="help-block">{{ $t('modal.cant_export_table.max_limit') }}{{ reportExportLimit }}{{ $t('modal.cant_export_table.select_interval') }}</h4>
      </div>
    </div>

    <div slot="footer">
      <button class="btn btn-default" @click="modalClose()">{{ $t('general.actions.close') }}</button>
    </div>
  </layout-general>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LayoutGeneral from './layout/General.vue';

export default {
  components: {
    LayoutGeneral,
  },
  computed: mapGetters({
    reportExportLimit: 'reportExportLimit',
    modalVisible: 'modalVisible',
  }),
  methods: mapActions([
    'modalClose',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** CantExportTable.vue?33ead107
 **/